var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 80,
    viewBox: "0 0 64 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6501 16.895C32.6224 16.895 31.7882 16.0609 31.7882 15.0331C31.7882 7.83513 37.6271 2 44.8214 2C45.8527 2 46.6835 2.83412 46.6835 3.86187C46.6835 11.0599 40.8481 16.895 33.6501 16.895Z",
    stroke: "#00B8E5",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8354 56.1003C61.5537 56.6404 61.7885 57.6195 61.3826 58.4243C54.8291 71.5389 49.6008 78.0707 44.8231 78.0707C42.6001 78.0707 40.4142 77.3518 38.2842 75.9515C35.1823 73.9074 31.1793 73.8216 27.9918 75.7282C25.4112 77.2735 22.9536 78.0707 20.6187 78.0707C13.592 78.0707 2 56.4317 2 44.5569C2 31.8812 8.64691 22.2144 18.7569 22.2144C23.5121 22.2144 27.6194 22.9144 31.0676 24.3369C32.531 24.9401 34.1844 24.8954 35.6106 24.2103C38.4108 22.866 42.101 22.2144 46.6851 22.2144C52.278 22.2144 57.1525 24.9997 61.2076 30.4066C61.8221 31.2295 61.658 32.3951 60.8354 33.0132C56.3108 36.4055 54.1325 40.2186 54.1325 44.5569C54.1325 48.895 56.3108 52.7081 60.8354 56.1003Z",
    stroke: "#00B8E5",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIos);
export default __webpack_public_path__ + "static/media/ios.cf9a3336cec2c637ad166d32d469cf98.svg";
export { ForwardRef as ReactComponent };